import angular from 'angular';
import ngRoute from 'angular-route';
import { userBar } from 'app/components/global';
import routes from './membership.routes';
import login from './login';
import passwordForm from './password';
import passwordResetForm from './passwordReset';
import blockActiveDirectory from './blockActiveDirectoryUser';


export default angular.module('app.components.membership', [
  ngRoute,
  login,
  userBar,
  passwordForm,
  passwordResetForm,
  blockActiveDirectory
])
  .config(routes)
  .name;

console.log('app.components.membership created');
